import {sortPriceResaleScript, sortPriceRentalsScript, sortRentMinScript, scoreScript} from './sortScripts'

function getQuery({affiliate, list_type, geo, price_mm, beds_mm, baths_mm, features,
                    properties, acres_mm, sqfeet_mm, showcase, detailItemKey, ad_number,
                    sortby, mapSearch, mapBounds, maxResults, saved, page}){

    if (list_type === "open_house") {
        features = Array.from(new Set(features).add("open_house"))
    }
    list_type = list_type === "open_house"
        ? "resale"
        : list_type;

    let index_type = {
        "rentals": "adirentals",
        "resale": "adiresale"
    }[list_type];

    const from = page * maxResults;

    const list_types = (saved === 'fav_all')
                        ? ["resale", "rentals", "community"]
                        : (list_type === 'resale')
                            ? [list_type]
                            : ["rentals", "community"];

    let filters = [];
    let geoScoreFilters = [];

    const premierOrder = { "premier_listing.keyword": { "order": "desc" } };
    const showcaseOrder = { "showcase_home.keyword": { "order": "desc" } };

    //order showcase and premier first for all searches if affiliate is syracuse, for searches, use premier order only
    const showcasePremierForSearchQuery = affiliate === "RE_syr" ? [showcaseOrder, premierOrder] : [premierOrder];
    //order showcase and premier first for all searches if affiliate is syracuse, for showcase serarch, use showcase order only
    const showcasePremierForShowcaseQuery = affiliate === "RE_syr" ? [showcaseOrder, premierOrder] : [showcaseOrder];

    const orderDirection = sortby.indexOf(':d') === -1 ? 'asc' : 'desc';
    const sortScore = {
        "_script": {
            "type": "number",
            "order": "desc",
            "script": {
                "lang": "painless",
                "source": scoreScript
            }
        }
    };
    const sortPriceResale = [
        ...showcasePremierForSearchQuery,
        {
            "_script": {
                "script": {
                    "lang": "painless",
                    "source": sortPriceResaleScript,
                    "params": {
                        "order": orderDirection
                    }
                },
                "type": "number",
                "order": orderDirection
            }}];
    const sortCreateDate = [...showcasePremierForSearchQuery, "_score", { "date_created": { "order": orderDirection } }];
    const sortSqFt = [...showcasePremierForSearchQuery, { "number_sqfeet": { "order": orderDirection } }];
    const sortPriceRentals = [
        ...showcasePremierForSearchQuery,
        {
            "_script": {
                "script": {
                    "lang": "painless",
                    "source": sortPriceRentalsScript,
                    "params": {
                        "order": orderDirection
                    }
                },
                "type": "number",
                "order": orderDirection
            }
        },
        {
            "_script": {
                "script": {
                    "lang": "painless",
                    "source": sortRentMinScript,
                    "params": {
                        "order": orderDirection
                    }
                },
                "type": "number",
                "order": orderDirection
            }}];
    const sortRentCreateDate = [...showcasePremierForSearchQuery, "_score", { "date_created": { "order": orderDirection } }];

    let sortScript = {
        'resale': {
            "price:d": sortPriceResale,
            "price": sortPriceResale,
            "date_created:d": sortCreateDate,
            "number_sqfeet:d": sortSqFt
        },
        "rentals": {
            "price:d": sortPriceRentals,
            "price": sortPriceRentals,
            "date_created:d": sortRentCreateDate
        }
    }[list_type][sortby];

    let featuresFilters = {
        just_listed: {"terms":{"just_listed":["on","On","ON"]}},
        new_construction: {terms: {condition: ["New", "To Be Built", "Under Construction"]}},
        foreclosure: {terms:{"foreclosure":["on","yes"]}},
        waterfront: {"terms":{"waterfront":["on","yes"]}},
        heating_cooling: {"terms":{"heating_cooling":["Central Air","Wall Units","Window Units","Zoned","Solar Cooling","Forced Air","conversion","dual system"]}},
        basement: {"terms":{"basement":["1","Yes","Basement Exists"]}},
        fireplace: {"terms":{"amenities":["Fireplace"]}},
        parkinggarage: {"terms":{"amenities":["Garage","Carport","Parking"]}},
        pool: {"terms":{"amenities":["Pool"]}},
        golf_course: {"term":{"lot_description":"golf"}},
        pets_exists: {"terms":{"pets_exists":["on","yes"]}},
        parking_exists: {"terms":{"parking_exists":["on","yes"]}},
        air_conditioning_exists: {"terms":{"air_conditioning_exists":["on","yes"]}},
        furnished: {"terms":{"furnished":["on","yes"]}},
        affordable_housing: {"terms":{"affordable_housing":["on","yes"]}},
        utilities_included: {"terms":{"utilities_included":["on","yes"]}}
    };

    if (geo || (mapSearch && mapBounds)) {
        if (mapSearch) {
            filters.push(getGeoBB(mapSearch, mapBounds));
        } else {
            filters.push(getGeo(geo));
            geoScoreFilters = getGeoScoringFunctions(geo);
        }
    }
    if (acres_mm) {
        // { "lte": "3000000", "gte": "2000000" } - you can omit either attribute, gte or lte
        filters.push({"range": { "acres": acres_mm}});
    }
    if (sqfeet_mm) {
        // { "lte": "3000000", "gte": "2000000" } - you can omit either attribute, gte or lte
        filters.push({"range": { "number_sqfeet": sqfeet_mm}});
    }
    if (price_mm) {
        // { "lte": "3000000", "gte": "2000000" } - you can omit either attribute, gte or lte
        list_type === 'resale'
            ? filters.push({"range": { "price": price_mm}})
            : filters.push({"bool": {"should": [{"bool": {"must": [{"range": {"price": price_mm}}, {"term": {"rent_min": "0"}}, {"term": {"rent_max": "0"}}]}},
                                                {"bool": {"must": [{"range": {"rent_min": price_mm}}, {"term": {"price": "0"}}]}},
                                                {"bool": {"must": [{"range": {"rent_max": price_mm}}, {"term": {"price": "0"}}]}}
                                               ]}});
    }
    if (beds_mm) {
        // [1, 1.5, 2, 2.5, 3] - the range is generated in the component code.
        list_type === 'resale'
            ? filters.push({"range": { "beds": beds_mm } })
            : filters.push({"bool": {"should": [{"bool": {"must": [{"range": {"beds": beds_mm}}, {"term": {"bed_min": "0"}}, {"term": {"bed_max": "0"}}]}},
                                                {"bool": {"must": [{"range": {"bed_min": beds_mm}}, {"term": {"beds": "0"}}]}},
                                                {"bool": {"must": [{"range": {"bed_max": beds_mm}}, {"term": {"beds": "0"}}]}}
                                               ]}});
    }
    if (baths_mm) {
        // [1, 1.5, 2, 2.5, 3] - the range is generated in the component code.
        list_type === 'resale'
            ? filters.push({"range": { "baths": baths_mm } })
            : filters.push({"bool": {"should": [{"bool": {"must": [{"range": {"baths": baths_mm}}, {"term": {"bath_min": "0"}}, {"term": {"bath_max": "0"}}]}},
                                                {"bool": {"must": [{"range": {"bath_min": baths_mm}}, {"term": {"baths": "0"}}]}},
                                                {"bool": {"must": [{"range": {"bath_max": baths_mm}}, {"term": {"baths": "0"}}]}}
                                               ]}});
    }

    // Features filters -- filter out Open House, which is actually a field we will check for existence
    const real_features = features.filter((item) => item !== 'open_house');
    if (real_features.length) {
        real_features.map((item) => filters.push(featuresFilters[item]));
    }

    // Construct the Open House field-exists filter as a list to append.
    // For some reason it can't be "anded" with the term filters, it seems.
    const open_house = features.indexOf('open_house') !== -1
        ? [{
            "exists": {
                "field": "open_house"
            }
        }]
        : [];

    // Property type filters
    if (properties.length && properties.length > 0) {
        let property_filters = [];
        if (properties.indexOf("Senior Community") !== -1) {
            property_filters.push({"term": {"community_type": "senior"}});
        }
        property_filters.push({"terms": {"property_type": properties}});
        filters.push({ "bool": { "should": property_filters } })
    }

    // Premier listing test
    //filters.push({"terms": { "premier_listing": ["on","yes"] } });

    // build ES queries for basic query, showcase query, detail modal query
    const affiliateListTypeFilter = {
        "bool": {
            "must": [
                {"term": {"affiliate": affiliate}},
                {"term": {"status": "active"}},
                {"terms": {"list_type": list_types}}
            ].concat(open_house)
        }
    }

    const searchQuery = {
            "index_type": index_type,
            "query": {
                "sort": sortScript,
                "from": from,
                "track_scores": true,
                "track_total_hits": true,
                "query": {
                    "function_score": {
                        "query": {
                            "bool": {
                                "must": {
                                    "match_all": {}
                                },
                                "filter": [
                                    affiliateListTypeFilter,
                                    ...filters
                                ]
                            }
                        },
                        "functions": getScoringFunctions(list_type)
                            .concat(geo
                                ? mapSearch
                                    ? []
                                    : geoScoreFilters
                                : []),
                        "score_mode": "multiply",
                        "boost_mode": "multiply"
                    }
                },
                "size": maxResults
            },
            "order_by": sortby
        }
    const detailPageFilters = [{"filter": {"term": {"ad_id" : detailItemKey} }, "random_score": {}, "weight": 1000},
                               {"filter" : {"match_all": {}}, "random_score": {},"weight": 1}]

    const detailPageQuery = {
            "index_type": index_type,
            "query": {
                "from": from,
                "track_scores": true,
                "track_total_hits": true,
                "query": {
                    "function_score": {
                        "query": {
                            "bool": {
                                "must": {
                                    "match_all": {}
                                },
                                "filter": [
                                    affiliateListTypeFilter,
                                    ...filters
                                ]
                            }
                        },
                        "functions": geoScoreFilters.concat(detailPageFilters),
                        "boost_mode": "max"
                    }
                },
                "size": maxResults
            },
            "order_by": "random"
        }

    const adNumberFilters = [{"multi_match": {"query": ad_number, "type": "best_fields", "fields":["web_id", "ad_number"]}}];

    const adNumberQuery = {
            "index_type": index_type,
            "query": {
                "from": from,
                "track_scores": true,
                "track_total_hits": true,
                "query": {
                    "function_score": {
                        "query": {
                            "bool": {
                                "must": {
                                    "match_all": {}
                                },
                                "filter": [
                                    affiliateListTypeFilter,
                                    ...adNumberFilters
                                ]
                            }
                        },
                        "functions": [],
                        "boost_mode": "max"
                    }
                },
                "size": maxResults
            },
            "order_by": "random"
        }

    const showcaseFilters = [{"filter": {"terms": {"showcase_home": ["On", "on", "ON"]}},
                                        "random_score": {}, "weight": 1000},
                             {"filter" : {"match_all": {}}, "random_score": {},"weight": 1}];

    const showcaseQuery ={
        "index_type": index_type,
        "query": {
            "sort": [sortScore, ...showcasePremierForShowcaseQuery],
            "from": from,
            "track_scores": true,
            "track_total_hits": true,
            "query": {
                "function_score": {
                    "query": {
                        "bool": {
                            "must": {
                                "match_all": {}
                            },
                            "filter": [
                                affiliateListTypeFilter,
                                ...filters
                            ]
                        }
                    },
                    "functions": geoScoreFilters.concat(showcaseFilters),
                    "boost_mode": "max"
                }
            },
            "size": maxResults
        },
        "order_by": "random"
    }

    const favoritesQuery = {
            "index_type": "adirentals,adiresale",
            "query": {
                "from": from,
                "track_total_hits": true,
                "query": {
                    "function_score": {
                        "query": {
                            "bool": {
                                "must": {
                                   "terms": {"ad_id" : JSON.parse(window.localStorage.advReLikes || "[]")}
                                },
                                "filter": affiliateListTypeFilter
                            }
                        }
                    }
                },
                "size": maxResults
            },
            "order_by": "random"
        }

    if (saved === 'fav_all') {
        return favoritesQuery
    } else if (mapSearch && mapBounds) {
        return searchQuery
    } else if (detailItemKey) {
        return detailPageQuery
    } else if (ad_number) {
        return adNumberQuery
    } else if (showcase || sortby === 'showcase') {
        return showcaseQuery
    } else {
        return searchQuery
    }
}

function getGeo({zip, city_state, county_state, ll_dist}) {
    let geo_or = [];
    if (zip) {
        geo_or.push({"term": {"zipcode": zip}});
    }
    if (city_state) {
        const the_state = city_state.state ? city_state.state : "";
        geo_or.push({"bool":{"must":[
            {"match":{"city": city_state.city}},
            {"match":{"state": the_state}}]
        }});
    }
    if (county_state) {
        const the_state = county_state.state ? county_state.state : "";
        geo_or.push({"bool":{"must":[
            {"match":{"county": county_state.county}},
            {"match":{"state": the_state}}]
        }});
    }
    if (ll_dist) {
        const distance = ll_dist.distance ? ll_dist.distance + "miles" : "10miles";
        geo_or.push({"geo_distance":
            {"distance": distance,"location":{"lat": ll_dist.lat,"lon": ll_dist.lon}}
        })
    }
    return {
        "bool": {
            "should": geo_or
        }
    }
}

function getGeoBB(mapSearch, mapBounds) {
    let geo_or = [];
    if (mapSearch && mapBounds) {
        geo_or.push({"geo_bounding_box":
                    {"location":{"top_left": {"lat": mapBounds.neLat,"lon": mapBounds.swLng}, "bottom_right": {"lat": mapBounds.swLat,"lon": mapBounds.neLng}}}
        })
    }
    return {
        "bool": {
            "should": geo_or
        }
    };
}

function getGeoScoringFunctions({zip, city_state, county_state, ll_dist}) {
    const the_city = city_state && !county_state ? city_state.city : "";
    const the_county = county_state && !city_state ? county_state.county : "";
    const the_state = city_state ? city_state.state
        : county_state ? county_state.state
            : "";
    const distance = ll_dist ? ll_dist.distance + "miles" : "10miles";
    const latlong = ll_dist ? "" + ll_dist.lat + "," + ll_dist.lon : "";
    const city_county_match_filter_boost =
        {
            "filter": {
                "bool": {
                    "must": [
                        {"match": the_city ? {"city": the_city}
                            : the_county ? {"county": the_county}
                                : ""},
                        {"match": {"state": the_state}}
                    ]
                }
            },
            "weight": 2.0
        };
    const zip_match_filter_boost =
        {
            "filter": [
                { "match": { "zipcode": zip }}
            ],
            "weight": 2.0
        };
    const city_county_match_gauss_filter =
        latlong
        ?{
            "filter": {
                "bool": {
                    "must_not": {
                        "match": the_city ? {"city": the_city}
                            : the_county ? {"county": the_county}
                                : ""
                    }
                }
            },
            "gauss": {
                "location": {
                    "scale": "1miles",
                    "offset": distance,
                    "origin": latlong
                }
            }
        }
        :{
            "filter": {
                "bool": {
                    "must_not": {
                        "match": {"city": the_city}
                    }
                }
            },
            "gauss": {
                "location": {
                    "scale": "1miles",
                    "offset": distance
                }
            }
        };
    const zip_match_gauss_filter =
        latlong
        ?{
            "filter": {
                "bool": {
                    "must_not": {
                        "term": {
                            "zipcode": zip
                        }
                    }
                }
            },
            "gauss": {
                "location": {
                    "scale": "1miles",
                    "offset": distance,
                    "origin": latlong
                }
            }
        }
        :{
            "filter": {
                "bool": {
                    "must_not": {
                        "term": {
                            "zipcode": zip
                        }
                    }
                }
            },
            "gauss": {
                "location": {
                    "scale": "1miles",
                    "offset": distance
                }
            }
        };
    return the_city || the_county ? [city_county_match_filter_boost, city_county_match_gauss_filter]
        : [zip_match_filter_boost, zip_match_gauss_filter];
}

function getScoringFunctions(list_type) {
    return list_type === "community"
        ? [{
                "filter": {
                    "term": {
                        "no_charge_listing_flag": 0
                    }
                },
                "weight": 1.1
        }]
        : [{
            "filter": {
                "terms": {
                    "priority_sort": ["On", "on"]
                }
            },
            "weight": 1
        }]
}

export default getQuery;

